import { useQuery } from "@tanstack/react-query";

import { searchPartsQuery } from "#modules/parts/infra/searchParts.query";
import { FilterQuery } from "shared";

export const useSearchParts = ({
  filtersParams,
  limit,
}: {
  filtersParams: FilterQuery;
  limit?: number;
}) => {
  const { data, ...rest } = useQuery({
    ...searchPartsQuery(filtersParams, limit),
  });

  return { parts: data, ...rest };
};
